import PropTypes from 'prop-types';

import ModalWindow from '../../common/Modal/ModalWindow';
import { TikTokBrandIdMapper } from './TikTokBrandIdMapper';

export function TikTokBrandIdMapperModal({ open, onClose, supplierId, retailerId, mapping }) {
  return (
    <ModalWindow open={open} onClose={onClose}>
      <TikTokBrandIdMapper
        supplierId={supplierId}
        retailerId={retailerId}
        onSkip={onClose}
        onContinue={onClose}
        currentMapping={mapping}
        resetOnSkip={false}
      />
    </ModalWindow>
  );
}

TikTokBrandIdMapperModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  supplierId: PropTypes.number.isRequired,
  retailerId: PropTypes.number.isRequired,
  mapping: PropTypes.object,
};
